import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { useTranslation } from 'react-i18next'
import type { IncidentCategory } from '@/data/types'

interface Props {
  data: Array<{ category: IncidentCategory; count: number }>
  height?: number
}

const COLOR_MAP: Record<IncidentCategory, string> = {
  payment: 'var(--brand-accent)',
  sync: 'var(--brand-primary)',
  hardware: 'var(--signal-warn)',
  training: 'var(--brand-secondary)',
  connectivity: 'var(--signal-good)',
  other: 'var(--ink-subtle)',
}

export function IncidentCategoryDonut({ data, height = 180 }: Props) {
  const { t } = useTranslation()
  const dataset = data.map((d) => ({
    name: t(`incidents.category.${d.category}`),
    value: d.count,
    key: d.category,
  }))
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={dataset}
          dataKey="value"
          nameKey="name"
          innerRadius={48}
          outerRadius={74}
          paddingAngle={2}
          stroke="var(--surface-1)"
        >
          {dataset.map((d) => (
            <Cell key={d.key} fill={COLOR_MAP[d.key as IncidentCategory]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            background: 'var(--surface-1)',
            border: '1px solid var(--border)',
            borderRadius: 12,
            fontSize: 12,
            color: 'var(--ink)',
          }}
        />
      </PieChart>
    </ResponsiveContainer>
  )
}
